<template>
    <layout-user containerClass="bg-white">
        <form autocomplete="off" @submit.prevent="reset" method="post" data-vv-scope="form">
            <div class="row mt-2 mt-sm-0 mb-4">
                <div class="col-sm-12">
                    <h1 class="title text-center text-sm-left">{{this.pageSubTitle}}</h1>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <MaterialInput type="text" class="city-form-group city-bg form-xl" id="input-email" name="email" v-model.trim="form.email" v-validate="'required|email'" :inputClasses="['form-control-xl', {'is-invalid': $root.fnHasError('form.email',this)}]" :error="errors.first('form.email')">Email</MaterialInput>
                </div>
            </div>
            <div class="row mb-4">
                <div class="col-sm-12">
                    <p>Antes de continuar, verifique o seu e-mail para obter um link de verificação. Se você não recebeu o email, solicite novo link indicando o seu e-mail.</p>
                </div>
            </div>
            <div class="row justify-content-center pt-sm-3">
				<div class="col-12 col-sm-6 mx-0 order-2 order-sm-1">
					<router-link
						:to="{ name: 'portal.login' }"
						class="btn btn-outline-main btn-lg btn-responsive min-w-auto z-depth-0 btn-block">
						{{ this.cancelTitle }}
					</router-link>
				</div>
				<div class="col-12 col-sm-6 mx-0 order-1 order-sm-2">
					<button
						class="btn btn-main btn-rounded btn-lg btn-responsive min-w-auto z-depth-0 btn-block mb-3 mb-sm-0 text-nowrap"
						type="submit"
						:disabled="isDisabled">
						{{ this.submitTitle }}
					</button>
				</div>
			</div>
        </form>
    </layout-user>
</template>

<script>
    import mixin from '../../mixin'
    import LayoutUser from '../../layouts/User.vue'

    export default {
        mixins: [mixin],
        components: {
            'layout-user': LayoutUser,
        },
        data() {
            return {
                pageID: 'resendverificationemail',
                pageTitle: 'Reenviar email de verificação', //'Resend verification email',
                pageSubTitle: 'Verifique seu endereço de e-mail',//'Verify Your Email Address',
                submitTitle: 'Solicitar novo link',
                cancelTitle: 'Cancelar',
                form: {
                  email: null,
                }
            }
        },
        methods: {
            reset() {
                this.clearMessages();

                this.$validator.validateAll('form').then(result => {
                    if(!result) {
                        this.showError('Por favor corrija os erros no formulário', this.pageTitle);
                        return;
                    }

                    let formData = new FormData();
                    formData.append('email', this.form.email);

                    this.$http.post(this.url.send, formData)
                    .then(res => {
                        this.showMessage(res.data.data, this.pageTitle, 'success', () =>
                        {
                            this.$router.push({name: 'portal.login'})
                        });
                    })
                    .catch(error => {
                        this.showHttpError(error);
                    });
                });
            }
        }
    }
</script>

<style scoped lang="scss">
    .reset-password{
        padding-left:0px;
    }
</style>